import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

export interface SocialLinks {
  [key: string]: string;
}

export const useSocialLinks = () => {
  const [links, setLinks] = useState<SocialLinks>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      const { data } = await (supabase
        .from("cms_settings" as any)
        .select("value")
        .eq("id", "social_links")
        .maybeSingle() as any);
      if (data?.value) setLinks(data.value as SocialLinks);
      setLoading(false);
    };
    fetch();
  }, []);

  return { links, loading };
};
